import React from 'react';
import { ArrowUpRight, Clock, Calendar } from 'lucide-react';
import { Link } from 'react-router-dom';
export interface BlogPost {
  id: number;
  title: string;
  excerpt: string;
  category: string;
  author: string;
  date: string;
  readTime: string;
  image: string;
}
interface BlogCardProps {
  post: BlogPost;
}
export function BlogCard({
  post
}: BlogCardProps) {
  return <Link to={`/blog/${post.id}`} className="block h-full" data-id="element-15">
      <article className="group flex flex-col h-full border border-white/10 bg-black hover:border-yellow-400 transition-colors duration-300" data-id="element-16">
        <div className="relative overflow-hidden aspect-[16/9]" data-id="element-17">
          <img src={post.image} alt={post.title} className="object-cover w-full h-full transition-transform duration-700 group-hover:scale-110 grayscale group-hover:grayscale-0" data-id="element-18" />
          <div className="absolute top-4 left-4 bg-yellow-400 text-black text-xs font-bold px-3 py-1 uppercase tracking-wider" data-id="element-19">
            {post.category}
          </div>
        </div>

        <div className="flex flex-col flex-grow p-6" data-id="element-20">
          <div className="flex items-center text-xs text-gray-500 mb-4 space-x-4" data-id="element-21">
            <span className="flex items-center" data-id="element-22">
              <Calendar className="w-3 h-3 mr-1" data-id="element-23" />
              {post.date}
            </span>
            <span className="flex items-center" data-id="element-24">
              <Clock className="w-3 h-3 mr-1" data-id="element-25" />
              {post.readTime}
            </span>
          </div>

          <h3 className="text-xl font-bold text-white mb-3 group-hover:text-yellow-400 transition-colors line-clamp-2" data-id="element-26">
            {post.title}
          </h3>

          <p className="text-gray-400 text-sm leading-relaxed mb-6 line-clamp-3 flex-grow" data-id="element-27">
            {post.excerpt}
          </p>

          <div className="flex items-center justify-between pt-4 border-t border-white/10 group-hover:border-yellow-400/30 transition-colors" data-id="element-28">
            <span className="text-xs font-bold text-gray-500 uppercase tracking-wider" data-id="element-29">
              By {post.author}
            </span>
            <span className="text-yellow-400 opacity-0 group-hover:opacity-100 transition-opacity duration-300" data-id="element-30">
              <ArrowUpRight className="w-5 h-5" data-id="element-31" />
            </span>
          </div>
        </div>
      </article>
    </Link>;
}